import { useEffect, useState } from "react";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import { createErrorText } from "../Functions";

const MoveExamDialog = ({
  open,
  paths,
  pathString,
  handleCancel,
  copyExam,
}: {
  open: boolean;
  paths: Record<string, ExamOverviewRow[]> | null;
  pathString: string;
  handleCancel: () => void;
  copyExam: (targetPath: string) => void;
}) => {
  const [name, setName] = useState("");
  const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
  const itemName = selectedRow?.name + " Kopie";
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    if (!open) {
      setName("");
    } else {
      setName(itemName);
    }
  };

  useEffect(() => {
    resetFields();
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, pathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={handleCancel}
      handleConfirm={() => copyExam(name)}
      title={"Prüfung kopieren"}
      description={"Benenne deine Prüfung"}
      confirmText={"Kopieren"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            copyExam(name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default MoveExamDialog;
